<template>
  <div class="circle-loader" :class="loadingComplete" v-if="loading">
    <div class="checkmark draw" :class="displayBlock"></div>
  </div>
</template>
<script>
import("./style.css");

export default {
  name: "Loader",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    success: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    loadingComplete: function() {
      if (this.success) {
        return "load-complete";
      }
      return;
    },
    displayBlock: function() {
      if (this.success) {
        return "displayBlock";
      }
      return;
    },
  },
};
</script>
